import React from "react";
import { List, Record } from "immutable";
import { RootState } from "common/reducers";
import { NavigatorActionItem } from "common/components/Navigator/types";

interface NavigatorContextProps {
  availableActions: List<NavigatorActionItem>;
  addAction: (action: NavigatorActionItem) => void;
  removeAction: (action: NavigatorActionItem) => void;
}

const defaultNavigatorContextProps: NavigatorContextProps = {
  availableActions: List(),
  addAction: (action: NavigatorActionItem) => null,
  removeAction: (action: NavigatorActionItem) => null,
};

export class NavigatorContextRecord extends Record(defaultNavigatorContextProps) implements NavigatorContextProps {}

export const NavigatorContext = React.createContext(new NavigatorContextRecord());

export const NavigatorContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [availableActions, setAvailableActions] = React.useState<List<NavigatorActionItem>>(List());

  const addAction = (action: NavigatorActionItem) => {
    setAvailableActions((prev) => prev.push(action));
  };

  const removeAction = (action: NavigatorActionItem) => {
    setAvailableActions((prev) => prev.filter((a) => a !== action));
  };

  return (
    <NavigatorContext.Provider value={new NavigatorContextRecord({ availableActions, addAction, removeAction })}>
      {children}
    </NavigatorContext.Provider>
  );
};
